import { ReactComponent as UnexpectedFriends } from "../../../media/unexpectedFriends.svg";

import { Link } from "react-router-dom";

const PaymentFailure = ({ trackId, message }) => {
  return (
    <div>
      <div className="main-container">
        <UnexpectedFriends
          className="box50perc"
          alt="failure payment"
        ></UnexpectedFriends>
        <p className="heading-1 centerAlign red-1">پرداخت ناموفق</p>
        <p className="heading-1 centerAlign subject-1 grey-1 marginBottom5">{`کد رهگیری ${trackId}`}</p>
        <p className="subject-2 marginBottom10 grey-1 yekan">{message}</p>
        <Link
          to="/subscription"
          className="marginBottom0-4r heading-3 fill-container b-purple-1 radius1-5"
        >
          باشه
        </Link>
      </div>
    </div>
  );
};

export default PaymentFailure;
